import { createFileRoute } from '@tanstack/react-router'

import { BranchInformational } from '@/containers/BranchInformational'

export const Route = createFileRoute(
  '/_unauthenticated/setup/branch-informational'
)({
  component: BranchInformational,
})
